import React, { useEffect, useState } from 'react';
import { Dropdown } from 'primereact/dropdown';
import { useGetLookUpDropdownListQuery } from '../../api';
import { useLanguage } from '../../contexts/LanguageContext';

const OtherCostDropdown = ({ value, onChange, className, disabled }) => {
    const { getCurrentLanguageId } = useLanguage();
    const { th } = useLanguage();

    const [selectedCostType, setSelectedCostType] = useState(null);

    const { data: costTypeList = [], isLoading } = useGetLookUpDropdownListQuery({
        RowCount: 100,
        GroupCode: 'XXBOS_OTHER_COST_SELECT',
        LanguageId: getCurrentLanguageId()
    });

    const costTypeOptions = costTypeList.map((costType) => ({
        id: Number(costType.code),
        text: costType.translatedText,
        displayValue: costType.translatedText
    }));

    const handleSelectionChange = (e) => {
        setSelectedCostType(e.value);
        onChange(e.value ? e.value.id : '');
    };

    useEffect(() => {
        if (costTypeOptions.length > 0 && value) {
            const found = costTypeOptions.find((option) => option.id === value);
            if (found) {
                if (selectedCostType?.id !== found.id) {
                    setSelectedCostType(found);
                }
            }
        }
    }, [value, costTypeOptions]);

    return (
        <Dropdown
            value={selectedCostType}
            options={costTypeOptions}
            onChange={handleSelectionChange}
            optionLabel="displayValue"
            showClear
            className={className}
            placeholder={th('warrantyClaims.detail.otherCosts.costTypePlaceHolder')}
            loading={isLoading}
            disabled={disabled}
            itemTemplate={(option) => <div>{option.text}</div>}
        />
    );
};

export default OtherCostDropdown;
